import { render, staticRenderFns } from "./PdpaModal.vue?vue&type=template&id=d51d4c60&"
import script from "./PdpaModal.vue?vue&type=script&lang=js&"
export * from "./PdpaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports